import classNames from 'classnames';
import { CreateTag } from './CreateTag';
import { PopoverSelector } from '@ui/PopoverSelector';
import { SonarTag } from '@sonar-software/sonar-core';
import { SonarTagDisplay } from '.';
import { useTags } from '@hooks';

import { FULL_ROUTES, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { PropsWithChildren, useCallback, useState } from 'react';

export type TagPickerSelectHandler = ((tagId: number) => Promise<void>) | ((tagId: number) => void);

export interface TagPickerProps {
	className?: string;
	onDeselect: TagPickerSelectHandler;
	onSelect: TagPickerSelectHandler;
	selectedTagIds?: number[];
	singleSelect?: boolean;
	trigger?: 'hover' | 'click';
}

export const TagPicker: React.FC<PropsWithChildren<TagPickerProps>> = ({
	className,
	children,
	onDeselect,
	onSelect,
	selectedTagIds = [],
	singleSelect,
	trigger = 'hover'
}) => {
	const tags = useTags();
	const [ filterValue, setFilterValue ] = useState('');

	const matchesFilter = useCallback(
		(value: SonarTag) => {
			if (filterValue === '') {
				return true;
			}

			return value.name.toLowerCase().includes(filterValue.toLowerCase().trim());
		},
		[ filterValue ]
	);

	const renderTagItem = (tag: SonarTag) => <SonarTagDisplay
		noBorder
		tagId={ tag.id } />;

	return (
		<PopoverSelector
			className={ classNames('tag-picker', className) }
			footer={ <CreateTag onFinish={ onSelect } /> }
			itemRender={ renderTagItem }
			listItems={ tags.filter((tag) => !tag.autoTagged).filter(matchesFilter) }
			manageRoute={ FULL_ROUTES.TAGS_MANAGE }
			onDeselect={ (tag) => onDeselect(tag.id) }
			onSearch={ setFilterValue }
			onSelect={ (tag) => onSelect(tag.id) }
			placeholder={ PLACEHOLDERS_COPY.SEARCH_TAGS }
			selectedIds={ selectedTagIds }
			singleSelect={ singleSelect }
			trigger={ trigger }>
			<div>{ children }</div>
		</PopoverSelector>
	);
};
